// extracted by mini-css-extract-plugin
module.exports = {"studentAvatar":"styles_studentAvatar__3v4f7","studentExamInfo":"styles_studentExamInfo__2rYuw","iconSize":"styles_iconSize__iHx1B","iconWrapper":"styles_iconWrapper__3mIun"};